/**
 * useBoardsListScreen.js
 * ----------------------
 * Hook for Boards list screen using shared useMasterList.
 */
import { useMasterList } from '../../common/useMasterList';
import * as boardsApi from '../api/boardsApi';

export function useBoardsListScreen() {
  return useMasterList({
    entityName: 'Board',
    apiClient: boardsApi.boardsClient,
    fetchList: boardsApi.listBoards,
    archiveItem: boardsApi.archiveBoard,
    deleteItem: boardsApi.deleteBoard,
  });
}
